import './App.css';
import { BrowserRouter as Router } from "react-router-dom";
import Home from './components/Home.js';
import About from './components/About';
import Bar from "./components/Bar";
import Project from './components/Project';
import Connect from './components/Connect.js';
import EasterEgg from './components/EasterEgg.js';
import { useCallback, useEffect, useState } from 'react';

function Experience() {
  return (
    <section className="section experience" id="experience">
      <div className="section-label"><span>02</span><p>Experience</p></div>
      <div className="section-body">
        <div className="experience-intro"><h2>Engineering for environments where rigor matters.</h2></div>
        <div className="timeline">
          <article className="role role-current">
            <div className="role-meta"><span className="status-dot" />Current</div>
            <div><h3>Research Platform Engineer</h3><p className="company">Citadel Securities</p><p className="role-copy">Building and supporting the platforms that help researchers move from ideas to robust, production-ready systems.</p></div>
          </article>
          <article className="role">
            <div className="role-meta">Previously</div>
            <div><h3>Portfolio Implementation Analyst</h3><p className="company">AQR Capital Management</p><p className="role-copy">Worked at the intersection of quantitative research, portfolio construction, and implementation.</p></div>
          </article>
          <article className="role">
            <div className="role-meta">Education</div>
            <div><h3>Applied Mathematics–Computer Science, Sc.B.<br/>Economics, A.B.</h3><p className="company">Brown University · GPA 4.0</p></div>
          </article>
        </div>
      </div>
    </section>
  );
}

function App() {
  const [showPuzzle, setShowPuzzle] = useState(false);
  const closePuzzle = useCallback(() => setShowPuzzle(false), []);

  useEffect(() => {
    let typed = "";
    const listenForCode = (event) => {
      if (event.metaKey || event.ctrlKey || event.altKey) return;
      typed = (typed + event.key.toLowerCase()).slice(-4);
      if (typed === "cube") {
        setShowPuzzle(true);
        typed = "";
      }
    };
    window.addEventListener("keydown", listenForCode);
    return () => window.removeEventListener("keydown", listenForCode);
  }, []);

  return (
    <div className="App" id="start">
      <Router>
        <Bar onEasterEgg={() => setShowPuzzle(true)}/>
        <Home/>
        <About/>
        <Experience/>
        <Project/>
        <Connect/>
        <EasterEgg open={showPuzzle} onClose={closePuzzle}/>
      </Router>
    </div>
  );
}

export default App;
